export const QUERY_KEYS = {
    CATEGORY_MENU: [
        "category-menu"
    ]
};
